import {
    AuthServicesLoginInternal,
    AuthServicesLoginSilent,
    AuthServicesRecoveryPassword,
    AuthServicesGetUserDetails,
} from "@services/AuthServices";
import { UserServicesCreateUserTest } from "@services/UserServices";
import {GenericServicesEntityType, GenericServicesGetDropdowns} from "@services/GenericServices";
import {
    required,
    minLength,
    maxLength,
    isEmail,
} from "@src/utils/validations.js";
import { debounce } from "lodash";

export default {
    data() {
        return {
            email: "",
            password: "",
            showPassword: false,
            checkbox: true,
            valid: false,
            validRegister: false,

            rulesEmail: [
                (v) => !!v || this.$t("required-input"),
                (v) => isEmail(v) || this.$t("email-validate-input"),
            ],
            rulesPassword: {
                required: (value) => !!value || this.$t("required-input"),
                min: (v) =>
                    (v != undefined && v.length >= 8) || this.$t("min-8-chars"),
            },

            rulesRequired: [required],
            rulesTel: [required, maxLength(9), minLength(9)],

            modalRequest: {
                show: false,
                message: "",
                invalid: false,
            },
            items: [
                "Corporate",
                "Distribuidor/Importador",
                "Equipamentos e Ferramentas",
                "Fabricante de Peças",
                "Financeira",
                "Gestora de Frota",
                "Integrador",
                "OEM",
                "Oficina",
                "Outros",
                "Pneus",
                "Rede Oficina",
                "Retalhista",
                "Serviços",
            ],

            year: "",
            isRecovery: false,
            isRecoveryTrue: false,
            isCreateAccount: false,
            validRecovery: false,
            emailRecovery: "",

            logo: "",
            bgLogin: "",
            titleLogin: "",
            subTitleLogin: "",

            isValidEnv: process.env.VUE_APP_DOMAIN,

            register: {
                entityTypeId: null,
                nif: "",
                name: "",
                secondName: "",
                email: "",
                phone: "",
                acceptedTerms: false,
                entityName: "",
            },

            isRegisterTest: false,
            createSucess: false,
            entityType: [{ name: "Outros", value: "1" }],

            modalRequestRegister: {
                invalid: false,
                msg: "",
            },
        };
    },
    computed: {
        computedCheckUrl() {
            return window.location.href;
        },
    },
    watch: {
        computedCheckUrl: {
            handler: function (newValue, oldValue) {
                if (newValue) {
                    if (String(newValue).includes("recoveryPassword=true")) {
                        this.isRecovery = true;
                    }
                }
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        onClickBackToLogin() {
            this.isCreateAccount = false;
            this.register = {
                entityTypeId: null,
                nif: "",
                name: "",
                secondName: "",
                email: "",
                phone: "",
                acceptedTerms: false,
            };
        },
        clearDataBeforeLogin() {
            localStorage.clear();
            this.$cookies.remove("token", { secure: true, expires: 1 });
            this.$store.commit("auth/setState", {});
            this.$store.commit(
                "vehicleIdentification/setVehicleIdentificationClear"
            );
        },
        postLoginInternal() {
            this.clearDataBeforeLogin();

            this.$refs.recaptchaComponent.onSubmit();
            this.modalRequest.invalid = false;
            this.$store.commit("loadings/setStateLoadingTemplate", true);
            return AuthServicesLoginInternal(this.email, this.password)
                .then((response) => {
                    this.callbackLogin(response);
                })
                .catch((error) => {
                    this.$requestStatus.checkRequestStatus(
                        error.response.status,
                        this.$route.name
                    );
                    this.modalRequest.invalid = true;
                    this.password = "";
                    this.valid = false;
                })
                .finally(() => {
                    this.$store.commit(
                        "loadings/setStateLoadingTemplate",
                        false
                    );
                });
        },
        callbackLogin(response) {
            const userToken = response.data.result.token;
            this.$cookies.set("token", userToken, { secure: true });

            this.getLoginInternalDetails(
                userToken,
                response.data.result.cultureName
            );
        },
        postLoginSilent(token) {
            this.modalRequest.invalid = false;
            this.$store.commit("loadings/setStateLoadingTemplate", true);
            return AuthServicesLoginSilent(token)
                .then((response) => {
                    this.callbackLogin(response);
                })
                .catch((error) => {
                    this.$requestStatus.checkRequestStatus(
                        error.response.status,
                        this.$route.name
                    );
                    this.modalRequest.invalid = true;
                    this.email = "";
                    this.password = "";
                    this.valid = false;
                })
                .finally(() => {
                    this.$store.commit(
                        "loadings/setStateLoadingTemplate",
                        false
                    );
                });
        },
        getRecoveryPassword() {
            this.$store.commit("loadings/setStateLoadingTemplate", true);
            let email = this.emailRecovery;
            return AuthServicesRecoveryPassword(email)
                .then((response) => {
                    this.isRecoveryTrue = true;
                })
                .catch((error) => {
                    this.$requestStatus.checkRequestStatus(
                        error.response.status,
                        this.$route.name
                    );
                    this.modalRequest.show = true;
                    this.modalRequest.message =
                        error.response.data.errorMessage;
                    (this.emailRecovery = ""), (this.validRecovery = false);
                    throw new Error("error to recovery password", error);
                })
                .finally(() => {
                    this.$store.commit(
                        "loadings/setStateLoadingTemplate",
                        false
                    );
                });
        },
        getLoginInternalDetails: debounce(async function (
            userToken,
            cultureName,
            stayInPage = false
        ) {
            return await AuthServicesGetUserDetails(cultureName, userToken)
                .then((response) => {
                    localStorage.setItem("@datadrive:justLoggedIn", true);

                    let res = response.data.result;

                    let statePayload = {
                        token: userToken,
                        ...res,
                    };

                    statePayload = this.setupModules(statePayload);

                    localStorage.setItem(
                        "@datadrive:initialState",
                        JSON.stringify(res)
                    );

                    this.$store.commit("auth/setState", statePayload);

                    if (res.languageCode) {
                        this.$i18n.locale = res.languageCode;
                        this.$vuetify.lang.current = res.languageCode;
                    }

                    if (statePayload.acceptedTerms) {
                        if (!stayInPage) {
                            if (this.$route.query.user) {
                                // environmental management silent login
                                this.$router.push(
                                    `/backoffice/external-users/edit/${this.$route.query.user}/modules/environmental?token=${this.$route.query.token}`
                                );
                            } else if (statePayload.redirectBO) {
                                this.$router.push("/backoffice");
                            } else {
                                this.$router.push("/dashboard");
                            }
                        }
                    } else {
                        if (this.$route.name !== "terms-and-conditions") {
                            this.$router.push("/terms-and-conditions");
                        }
                    }

                    this.$store.commit("generics/clearStateGenericDropdowns");
                    GenericServicesGetDropdowns();
                })
                .catch((error) => {
                    this.$requestStatus.checkRequestStatus(
                        error.response.status,
                        this.$route.name
                    );
                    console.error(
                        "error getting login-internal-details",
                        error
                    );
                })
                .finally(() => {
                    this.$store.commit(
                        "loadings/setStateLoadingTemplate",
                        false
                    );
                });
        },
        100),
        limitKeypress(value, maxLength) {
            if (
                value != undefined &&
                value.toString().length >= maxLength &&
                event.keyCode != 8 &&
                event.keyCode != 46
            ) {
                event.preventDefault();
            }
        },
        setupModules(payload) {
            for (let key in payload.modules) {
                let itemModuleNotifications =
                    payload.modulesNotificationsCount.find(
                        (o) => o.name == String(payload.modules[key].moduleId)
                    );
                Object.assign(
                    payload.modules[key],
                    this.$helpers.getModuleConfigById(
                        payload.modules[key].moduleId
                    ),
                    {
                        notificationCount: itemModuleNotifications
                            ? +itemModuleNotifications.value
                            : 0,
                    }
                );

                if (payload.modules[key].isActive) {
                    if (
                        payload.modules[key].moduleId ===
                        this.$globals.MODULES.AUTOCOM.ID
                    ) {
                        Object.assign(payload.modules[key], {
                            url: payload.autoComLink,
                        });
                    }
                    if (
                        payload.modules[key].moduleId ===
                        this.$globals.MODULES.WEBSHOP.ID
                    ) {
                        Object.assign(payload.modules[key], {
                            url: payload.webShopUrl,
                        });
                    }
                    if (
                        payload.modules[key].moduleId ===
                        this.$globals.MODULES.DSB.ID
                    ) {
                        Object.assign(payload.modules[key], {
                            url: payload.dsbUrl,
                        });
                    }
                }
            }

            return payload;
        },
        createUserTeste() {
            this.modalRequestRegister.invalid = false;
            this.validRegister = false;
            this.$store.commit("loadings/setStateLoadingTemplate", true);
            let body = {
                entityTypeId: this.register.entityTypeId,
                entityName: this.register.entityName,
                nif: this.register.nif,
                name: this.register.name,
                secondName: this.register.secondName,
                email: this.register.email,
                phone: this.register.phone,
                acceptedTerms: this.register.acceptedTerms,
            };

            return UserServicesCreateUserTest(body)
                .then((response) => {
                    this.createSucess = true;
                })
                .catch((error) => {
                    this.$requestStatus.checkRequestStatus(
                        error.response.status,
                        this.$route.name
                    );
                    this.modalRequestRegister.invalid = true;
                    if (error.response.data.hasFieldErrors) {
                        this.modalRequestRegister.msg = Object.values(
                            error.response.data.fieldErrors
                        )[0][0];
                    } else {
                        this.modalRequestRegister.msg =
                            error.response.data.errorMessage;
                    }
                    throw new Error("error to do create", error);
                })
                .finally(() => {
                    this.$store.commit(
                        "loadings/setStateLoadingTemplate",
                        false
                    );
                });
        },
        clickCreateAccount() {
            this.modalRequest.invalid = false;

            this.$store.commit("loadings/setStateLoadingTemplate", true);

            return GenericServicesEntityType()
                .then((response) => {
                    this.entityType = response.data.result;
                    this.isCreateAccount = true;
                })
                .catch((error) => {
                    // this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    throw new Error("error to do dropdowns", error);
                })
                .finally(() => {
                    this.$store.commit(
                        "loadings/setStateLoadingTemplate",
                        false
                    );
                });
        },
        closeCreateSuccess() {
            this.isCreateAccount = false;
            this.createSucess = false;
        },
        handleBackToLogin() {
            this.isRecovery = false;
            this.isRecoveryTrue = false;
            const url = new URL(window.location.href);
            window.history.replaceState({}, document.title, url.origin);
        },
    },
    mounted() {
        this.year = new Date().getFullYear();
        this.$store.commit("loadings/setStateLoadingTemplate", true);
        this.$store.commit("loadings/setStateLoadingTemplate", false);

        let colors = JSON.parse(localStorage.getItem("@datadrive:domain"));

        if (colors) {
            this.logo = colors.companyLogoBeforeLogin;
            this.bgLogin = colors.backgroundImage;
            this.titleLogin = colors.loginTitle;
            this.subTitleLogin = colors.loginSubTitle;
            this.isRegisterTest = colors.hasAccountTestRegistry;
        }

        // execute silent login in case there is a silent login token in the query parameters
        if (this.$route.query.token) {
            this.postLoginSilent(this.$route.query.token);
        }
        if (this.$route.query.tempAccess) {
            const accessData = JSON.parse(atob(this.$route.query.tempAccess));
            if (
                accessData &&
                accessData.hasOwnProperty('email') &&
                accessData.hasOwnProperty('password')
            ) {
                this.email = accessData.email;
                this.password = accessData.password;
            }
        }
    },
};
